import React from 'react';
import { ROUTER_COOKIES } from 'app/AppRouter';
import { Container, Flex, Li, Link, MarginBox, Paragraph, Section, SectionHeader, Text, Ul } from 'UI';
import { useResetScroll } from 'utils/hooks/useResetScroll';
import { Country } from 'utils/i18n/Country';

export const PersonalDataTR = () => {
  useResetScroll();
  return (
    <Container size={'md'} alignText={'justify'}>
      <Flex direction={'column'}>
        <MarginBox mt={15} />
        <Flex direction={'column'} align={'center'}>
          <Text type={'h5_bold'}>RPARTSTORE</Text>
          <Text type={'h5_bold'}>KİŞİSEL VERİLERİN KORUNMASINA İLİŞKİN</Text>
          <Text type={'h5_bold'}>AYDINLATMA METNİ</Text>
          <MarginBox mt={30} />
        </Flex>
        <Section>
          <Paragraph>
            <Link to={'https://rpartstore.renault.com'} external newTab>
              {'https://rpartstore.renault.com'}
            </Link>{' '}
            adresinden erişilebilen RPARTSTORE web sitesi (&quot;Platform&quot;), Renault parça ve aksesuarlarına
            (&quot;Ürünler&quot;) ilişkin satış sonrası teknik dokümantasyonun incelenmesini kolaylaştırmak ve ayrıca
            Platformun Genel Hüküm ve Koşullarına uygun olarak, Ürünleri bir web sitesi aracılığıyla alıcılara
            (&quot;Alıcılar&quot;) satışa sunmak isteyen satıcıların (&quot;Satıcılar&quot;) bir araya getirilmesini
            sağlamak üzere kurulmuştur. Satıcılar ve Alıcılar birlikte &quot;Kullanıcılar&quot; olarak anılacaktır.
          </Paragraph>
          <Paragraph>
            Renault SAS (&quot;Renault&quot; veya &quot;Şirket&quot;), gerçek kişilere ait kişisel verilerin 6698 sayılı
            Kişisel Verilerin Korunması Kanunu (&quot;KVKK&quot;) ve sair mevzuat hükümlerine uygun şekilde işlenmesini
            amaçlamaktadır. Kişisel verilerin korunmasına ilişkin bu aydınlatma metninin amacı, Platformu kullanımınız
            kapsamında gerçekleştirilen kişisel veri işleme faaliyetlerine ilişkin aydınlatma yükümlülüğünün yerine
            getirilmesidir.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader title={'Verileriniz ne amaçla ve ne kadar süreyle kullanılıyor?'} />
          <Paragraph>
            Platformun kullanımı sırasında otomatik veya otomatik olmayan yöntemlerle, elektronik ortamda toplanan
            kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:
          </Paragraph>
          <Ul>
            <Li>
              <Text type={'text'}>
                Kimlik, iletişim ve teknik tanımlayıcılar kategorilerinde yer alan verileriniz, kişisel verilerinizin
                gizliliğini ve güvenliğini yönetme konusundaki, KVKK&apos;nın 5/2 (f) maddesi uyarınca temel hak ve
                özgürlüklerinize zarar vermemek kaydıyla meşru menfaatimiz temelinde veri işlemenin zorunlu olması
                hukuki sebebiyle <strong>Platformdaki erişim ve yetki haklarınızı yönetmek</strong> amacıyla
                işlenmektedir. Bu verileri, inaktif olmadığı sürece, kullanıcı hesabınızın açık olduğu süre boyunca
                işleriz.
              </Text>
            </Li>
            <Li>
              <Text type={'text'}>
                Teknik tanımlayıcılar kategorisinde yer alan verileriniz, Platformun bilgisayar güvenliğini garanti
                altına alma konusundaki, KVKK&apos;nın 5/2 (f) maddesi uyarınca temel hak ve özgürlüklerinize zarar
                vermemek kaydıyla yönelik meşru menfaatimiz temelinde veri işlemenin zorunlu olması hukuki sebebiyle{' '}
                <strong>uygulamaların ve ağların güvenliğini ve düzgün işleyişini yönetmek</strong> amacıyla
                işlenmektedir. Verilerinizi veritabanlarımızda 30 gün boyunca işleriz.
              </Text>
            </Li>
            <Li>
              <Text type={'text'}>
                Kimlik ve iletişim kategorilerinde yer alan kişisel verileriniz,{' '}
                <strong>
                  söz konusu olduğu durumlarda, kişisel verilerinizle ilgili haklarınızı kullanma taleplerinize,
                  KVKK&apos;nın 5/2 (ç) maddesi uyarınca hukuki yükümlülüklerimizin yerine getirilmesi veri işlemenin
                  zorunlu olması hukuki sebebiyle yasal ve/veya düzenleyici yükümlülüklerimiz uyarınca yanıt vermek
                  amacıyla işlenmektedir
                </strong>
                . Kişisel verileriniz, talebinize yanıt verebilmek için gerekli olan süre boyunca saklanır. Bununla
                birlikte, herhangi bir yasal işleme/davaya yanıt verebilmek için, haklarınızın kullanılmasına ilişkin
                yanıtımıza dair arşiv kanıtlarını (söz konusu olduğunda, bu amaç için derlediğimiz kişisel veriler
                dahil), geçerli mevzuatta belirtilen zaman aşımı süreleri boyunca saklamamız gerekmektedir.
              </Text>
            </Li>
          </Ul>
          <Paragraph>
            Ayrıca Platform, kendi işleyişini ve güvenliğini yönetmek ve{' '}
            <Link to={ROUTER_COOKIES(Country.TR.key)} external newTab>
              buradaki linkten erişebileceğiniz
            </Link>{' '}
            Platforma ilişkin Çerez Politikasında belirtilen koşullar kapsamında Platformun hedef kitlesini ve
            performansını ölçümlemek için çerezleri ve diğer izleme teknolojilerini kullanmaktadır.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader title={'Hangi kişisel veriler işlenmektedir?'} />
          <Paragraph>
            Topladığımız kişisel veriler sizinle olan etkileşimimize bağlı olup, aşağıdakiler hakkında bilgileri içerir:
          </Paragraph>
          <Ul>
            <Li>
              <Text type={'text'}>
                Kimlik ve iletişim bilgileriniz (soyadınız, adınız, iş posta adresiniz ve e-posta adresiniz);
              </Text>
            </Li>
            <Li>
              <Text type={'text'}>Teknik tanımlayıcılar (IPN numarası);</Text>
            </Li>
            <Li>
              <Text type={'text'}>
                Platformun{' '}
                <Link to={ROUTER_COOKIES(Country.TR.key)} external newTab>
                  Çerez Politikasına
                </Link>{' '}
                uygun olarak bağlantı verileri (aktivite kayıtları, çerezler).
              </Text>
            </Li>
          </Ul>
          <MarginBox mt={15} />
        </Section>
        <Section>
          <SectionHeader title={'Kişisel verileriniz kimin tarafından işleniyor?'} />
          <Paragraph>
            Yukarıda listelenen işleme faaliyetleri, söz konusu olduğu durumlarda ülkenizde faaliyet gösteren Renault
            iştirakleriyle işbirliği içinde hareket eden, Renault SAS tarafından gerçekleştirilir (*). Buna ek olarak,
            dağıtım faaliyetlerinden sorumlu olan, belirtilen kuruluşun ana ağının üyeleri olan Satıcılar, Renault
            Grubunun dahili dizinlerinde ve kimlik doğrulama araçlarında Kullanıcı profilleri oluşturarak Platformdaki
            erişim ve yetki haklarınızın yönetimi sürecine katılırlar.
          </Paragraph>
          <Paragraph>
            <i>
              (*) Ülkenizde faaliyet gösteren Renault iştirakinin yasal kimliğini öğrenmek için lütfen{' '}
              <Link to={'https://www.renaultgroup.com/en/directory/'} external newTab>
                dizinimizi ziyaret edin
              </Link>
              , listeden ülkenizi seçin ve yasal bilgilerine başvurun.
            </i>
          </Paragraph>
          <Paragraph>
            <i>
              Renault SAS, Fransa&apos;da, 122-122 bis avenue du Général Leclerc – 92 100 Boulogne-Billancourt adresinde
              bulunmaktadır. Veri koruma görevlisinin (DPO) iletişim bilgileri aşağıdaki gibidir: Renault SAS, Direction
              juridique (Hukuk Departmanı) – Délégué à la protection des données (Veri Koruma Görevlisi), 122-122 bis
              avenue du Général Leclerc – 92 100 Boulogne-Billancourt.
            </i>
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader title={'Kişisel verilerinize kimler erişebilir?'} />
          <Paragraph>
            Kişisel verileriniz, yukarıda belirtilen amaçlar doğrultusunda ve KVKK&apos;nın 8. ve 9. maddelerine uygun
            olarak aşağıdaki şekilde aktarılabilecektir:
          </Paragraph>
          <Ul>
            <Li>
              <Text type={'text'}>
                Kimlik ve iletişim bilgileriniz ile teknik tanımlayıcılarınız, erişim ve yetki haklarınızın yönetimi,
                platformun güvenliğinin ve düzgün işleyişinin sağlanması ile yasal yükümlülüklerimizin yerine
                getirilmesi amacıyla Renault Grubu bünyesindeki ilgili şirketlere aktarılabilecektir.
              </Text>
            </Li>
            <Li>
              <Text type={'text'}>
                Kimlik ve iletişim bilgileriniz ile teknik tanımlayıcılarınız, teknik ve lojistik destek hizmetlerinin
                alınması ve platformun işleyişinin ve güvenliğinin sağlanması amacıyla hizmet sağlayıcılarımıza ve
                tedarikçilerimize aktarılabilecektir.
              </Text>
            </Li>
            <Li>
              <Text type={'text'}>
                Kimlik ve iletişim bilgileriniz, yasal yükümlülüklerimizin yerine getirilmesi ve yetkili kurum ve
                kuruluşların taleplerinin karşılanması amacıyla yetkili kamu kurum ve kuruluşlarına aktarılabilecektir.
              </Text>
            </Li>
          </Ul>
          <Paragraph>
            Kişisel verileriniz yurt dışında bulunan üçüncü kişilere aktarılması halinde amaçla bağlantılı, sınırlı ve
            ölçülü şekilde olmak şartıyla, KVKK&apos;nın 9. maddesine ve Kişisel Verilerin Yurt Dışına Aktarılmasına
            İlişkin Usul ve Esaslar Hakkında Yönetmelik&apos;e uygun olarak uygun güvencelerden birinin mevcut olması
            veya arızi aktarım hallerinden birinin mevcut olması durumunda aktarılır.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader title={'Kişisel verilerinize ilişkin haklarınız nelerdir?'} />
          <Paragraph>
            KVKK&apos;nın 11. maddesi uyarınca, Şirketimize başvurarak kişisel verileriniz hakkında aşağıdaki konulara
            ilişkin taleplerde bulunabilirsiniz:
          </Paragraph>
          <Ul>
            <Li>
              <Text type={'text'}>Kişisel verilerinin işlenip işlenmediğini öğrenme,</Text>
            </Li>
            <Li>
              <Text type={'text'}>Kişisel verileri işlenmişse buna ilişkin bilgi talep etme,</Text>
            </Li>
            <Li>
              <Text type={'text'}>
                Kişisel verilerinin işlenme amacı ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme,
              </Text>
            </Li>
            <Li>
              <Text type={'text'}>
                Kişisel verilerinin yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri öğrenme,
              </Text>
            </Li>
            <Li>
              <Text type={'text'}>
                Kişisel verilerinin eksik veya yanlış işlenmiş olması halinde bunların düzeltilmesini isteme ve bu
                kapsamda yapılan işlemin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,
              </Text>
            </Li>
            <Li>
              <Text type={'text'}>
                Kişisel verilerinin işlenmesini gerektiren sebeplerin ortadan kalkması halinde bunların silinmesini, yok
                edilmesini veya anonim hale getirilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerin
                aktarıldığı üçüncü kişilere bildirilmesini isteme,
              </Text>
            </Li>
            <Li>
              <Text type={'text'}>
                İşlenen kişisel verilerinin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle veri
                sahibinin aleyhine bir sonucun ortaya çıkmasına itiraz etme,
              </Text>
            </Li>
            <Li>
              <Text type={'text'}>
                Kişisel verilerinin kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması halinde zararın
                giderilmesini talep etme.
              </Text>
            </Li>
          </Ul>
          <Paragraph>
            Tüm haklarınızı, talebinizi{' '}
            <Link to={'mailto:dpo@renault.com'} external newTab>
              dpo@renault.com
            </Link>{' '}
            adresine göndererek kullanabilirsiniz. Şirketimiz, KVKK&apos;nın 13. maddesine uygun olarak, Veri
            Sorumlusuna Başvuru Usul ve Esasları Hakkında Tebliğ&apos;in &quot;Başvuru Usulü&quot; başlıklı 5. maddesi
            2.fıkrasına uygun bulunması kaydıyla, başvuru taleplerinizi, talebin niteliğine göre ve en geç 30 (otuz) gün
            içinde ücretsiz olarak sonuçlandıracaktır. Talebin reddedilmesi halinde, ret nedeni/nedenleri tarafınıza
            yazılı olarak veya elektronik ortamda gerekçeleriyle bildirilir. Renault&apos;dan bir cevap veya tatmin
            edici bir yanıt gelmemesi halinde, yerel veri koruma makamınıza şikayette bulunabilirsiniz.
          </Paragraph>
        </Section>
        <Flex justify={'flex-end'}>
          <Text type={'text'}>Sürüm güncellenme tarihi: Ekim 2024</Text>
        </Flex>
        <MarginBox mt={90} />
      </Flex>
    </Container>
  );
};
